import { TRPCClientError } from '@trpc/client';

export function parseErrorMsg(error: unknown) {
  return error instanceof TRPCClientError && error.data?.code === 'BAD_REQUEST'
    ? error.message
    : undefined;
}
